<template>
  <div class="app-container">
    <!--       default-expand-all -->
    <div class="pcpdaClass">PC</div>
    <el-tree
      ref="treeRefPC"
      :data="permissionList.pc"
      :default-checked-keys="defSelectedPermissionList.pc"
      :props="props"
      icon-class="el-icon-thumb"
      node-key="id"
      show-checkbox
    />
    <div class="pcpdaClass" style="margin-top: 20px;">PDA</div>
    <el-tree
      ref="treeRefPDA"
      :data="permissionList.pda"
      :default-checked-keys="defSelectedPermissionList.pda"
      :props="props"
      icon-class="el-icon-thumb"
      node-key="id"
      show-checkbox
    />
  </div>
</template>

<script>
import { getPermissionStructureAll } from '@/api/permission';

export default {
  name: 'PermissionTree',
  props: {
    permissionTreePop: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      props: {
        label: 'name',
        children: 'children',
        disabled: 'disabled'
      },
      // 权限树
      permissionList: {
        pc: [],
        pda: []
      },
      // 选中了的节点
      selectedPermissionList: {
        pc: [],
        pda: []
      },
      // 默认选中节点
      defSelectedPermissionList: {
        pc: [],
        pda: []
      },
      userId: null
    };
  },
  mounted() {
    this.userId = this.$store.state.user.id;
    this.init();
  },
  methods: {
    /**
     * 递归标记角色权限节点为 disabled（只读）
     * 仅当当前节点及其整棵子树都属于角色权限时，父节点才禁用
     * @param {Array} nodes 权限树节点列表
     * @param {Set} roleIdSet 角色权限 ID 集合
     */
    markRoleNodes(nodes, roleIdSet) {
      if (!nodes || !nodes.length) return nodes;
      return nodes.map(node => {
        const children = node.children && node.children.length > 0
          ? this.markRoleNodes(node.children, roleIdSet)
          : [];
        const isRolePermission = roleIdSet.has(node.id) || roleIdSet.has(String(node.id));
        const hasChildren = children.length > 0;
        const allChildrenDisabled = hasChildren && children.every(child => child.disabled);
        const disabled = hasChildren ? isRolePermission && allChildrenDisabled : isRolePermission;
        return {
          ...node,
          disabled,
          children
        };
      });
    },
    collectSelectedNodes(nodes, selectedIdSet) {
      if (!nodes || !nodes.length) {
        return [];
      }
      const selectedNodes = [];
      const visit = (node) => {
        const children = node.children || [];
        const hasSelectedChild = children.map(visit).some(Boolean);
        const isSelected = selectedIdSet.has(node.id) || selectedIdSet.has(String(node.id));
        if (isSelected || hasSelectedChild) {
          selectedNodes.push(node);
          return true;
        }
        return false;
      };
      nodes.forEach(visit);
      return selectedNodes;
    },
    init() {
      getPermissionStructureAll().then((response) => {
        const {
          permissionStructurePc,
          permissionStructurePda,
          lastChildrenIdsPc,
          lastChildrenIdsPda,
          permissionStructureSchedule,
          lastChildrenIdsSchedule
        } = response.data;

        // 角色权限 ID 集合（用于标记只读节点）
        const rolePermissionPcIds = ((this.permissionTreePop.rolePermissionIds && this.permissionTreePop.rolePermissionIds.pc) || []);
        const rolePermissionPdaIds = ((this.permissionTreePop.rolePermissionIds && this.permissionTreePop.rolePermissionIds.pda) || []);
        const rolePermissionPcIdSet = new Set([...rolePermissionPcIds, ...rolePermissionPcIds.map(String)]);
        const rolePermissionPdaIdSet = new Set([...rolePermissionPdaIds, ...rolePermissionPdaIds.map(String)]);

        if (permissionStructurePc) {
          const filterPermissionNodes = (nodes, userId) => {
            return nodes.filter(node => {
              const shouldShow =
                node.code !== 'menu:system-manage:OperationRecord' ||
                (node.code === 'menu:system-manage:OperationRecord' && userId === 3817);

              if (shouldShow) {
                // 如果有子节点，继续递归过滤
                if (node.children && node.children.length > 0) {
                  node.children = filterPermissionNodes(node.children, userId);
                }
                return true;
              }

              return false;
            });
          };
          const filteredPc = filterPermissionNodes(permissionStructurePc, this.userId);
          // 标记角色权限节点为 disabled
          this.permissionList.pc = this.markRoleNodes(filteredPc, rolePermissionPcIdSet);
          if (this.permissionTreePop.selectedPermissionList.pc) {
            this.defSelectedPermissionList.pc = this.permissionTreePop.selectedPermissionList.pc.filter(
              (item) => {
                return lastChildrenIdsPc.indexOf(item) !== -1;
              }
            );
          }
        }
        if (permissionStructureSchedule) {
          this.permissionList.schedule = permissionStructureSchedule;
          if (this.permissionTreePop.selectedPermissionList.schedule) {
            this.defSelectedPermissionList.schedule = this.permissionTreePop.selectedPermissionList.schedule.filter(
              (item) => {
                return lastChildrenIdsSchedule.indexOf(item) !== -1;
              }
            );
          }
        }
        if (permissionStructurePda) {
          // 标记角色权限节点为 disabled
          this.permissionList.pda = this.markRoleNodes(permissionStructurePda, rolePermissionPdaIdSet);
          if (this.permissionTreePop.selectedPermissionList.pda) {
            this.defSelectedPermissionList.pda = this.permissionTreePop.selectedPermissionList.pda.filter(
              (item) => {
                return lastChildrenIdsPda.indexOf(item) !== -1;
              }
            );
          }
        }
      });
    },
    getSelectedPermissionList() {
      const checkedKeys = this.$refs.treeRefPC.getCheckedKeys();
      const halfCheckedKeys = this.$refs.treeRefPC.getHalfCheckedKeys();
      const checkedKeysPDA = this.$refs.treeRefPDA.getCheckedKeys();
      const halfCheckedKeysPDA = this.$refs.treeRefPDA.getHalfCheckedKeys();
      const pcSelectedIdSet = new Set([
        ...checkedKeys,
        ...halfCheckedKeys,
        ...checkedKeys.map(String),
        ...halfCheckedKeys.map(String)
      ]);
      const pdaSelectedIdSet = new Set([
        ...checkedKeysPDA,
        ...halfCheckedKeysPDA,
        ...checkedKeysPDA.map(String),
        ...halfCheckedKeysPDA.map(String)
      ]);
      const selectedNodes = [
        ...this.collectSelectedNodes(this.permissionList.pc, pcSelectedIdSet),
        ...this.collectSelectedNodes(this.permissionList.pda, pdaSelectedIdSet)
      ];
      const menuPermissions = [];
      const buttonPermissions = [];
      const permissionIds = [];
      const addedPermissionIds = new Set();
      const addedPermissionCodes = new Set();
      selectedNodes.forEach((item) => {
        if (item.id !== undefined && item.id !== null && !addedPermissionIds.has(item.id)) {
          addedPermissionIds.add(item.id);
          permissionIds.push(item.id);
        }
        if (!item.code || addedPermissionCodes.has(item.code)) {
          return;
        }
        addedPermissionCodes.add(item.code);
        const code = item.code.split(':')[0];
        if (code === 'menu') {
          menuPermissions.push(item.code);
        } else {
          buttonPermissions.push(item.code);
        }
      });

      return {
        permissionIds,
        menuPermissions,
        buttonPermissions
      }; // halfCheckedKeys.concat(checkedKeys);
    }
  }
};
</script>

<style scoped>
.pcpdaClass {
  line-height: 17px;
  font-size: 17px;
  padding: 5px;
  background: linear-gradient(to right, #ededed, #fff);
}

.el-tree {
  min-width: 100%;
  display: inline-block;
}

.tree {
  overflow: auto;
  max-height: 400px;
}

/* 角色权限节点样式：灰色文字，光标 not-allowed */
::v-deep .el-tree-node.is-checked > .el-tree-node__content .el-checkbox.is-disabled .el-checkbox__inner {
  background-color: #c0c4cc;
  border-color: #c0c4cc;
}

::v-deep .el-tree-node__content .el-checkbox.is-disabled {
  cursor: not-allowed;
}

::v-deep .el-tree-node__content .el-checkbox.is-disabled + span {
  color: #909399;
}
</style>
